"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resendVerificationCodeSchema = exports.verifyClaimSchema = exports.requestClaimAdditionSchema = exports.createCustomerSchema = exports.createAccountSchema = exports.stringPhoneSchema = exports.smartSigninSchema = exports.phoneSchema = exports.passwordlessLoginSchema = exports.passwordResetSchema = exports.emailSchema = exports.documentSchema = exports.authenticateSchema = exports.accountInformationSchema = void 0;

var _cpf = require("@fnando/cpf");

var _yup = require("yup");

var _isValidPhone = require("../utils/isValidPhone");

var _enums = require("../enums");

/* eslint-disable babel/no-invalid-this */
const onlyNumbers = value => String(value).replace(/[^0-9]/g, '');

const validateClaim = expectedType => (currentType, schema) => currentType === expectedType ? schema.required() : schema.optional();

const verificationTicketSchema = {
  verificationTicket: (0, _yup.string)().required(),
  verificationTicketExpiresInSeconds: (0, _yup.number)().required()
};
(0, _yup.addMethod)(_yup.string, 'cpf', function isCpf() {
  return this.transform(onlyNumbers).test('is-cpf', 'CPF is invalid.', value => (0, _cpf.isValid)(value));
});
(0, _yup.addMethod)(_yup.object, 'phone', function formatPhone() {
  return this.transform(phone => {
    return { ...phone,
      ...(phone ? {
        formatted: `(${phone === null || phone === void 0 ? void 0 : phone.areaCode}) ${phone === null || phone === void 0 ? void 0 : phone.number}`
      } : {})
    };
  });
});
(0, _yup.addMethod)(_yup.object, 'cellphone', function formatPhone() {
  return this.transform((value = {
    phone: ''
  }) => {
    const phone = onlyNumbers(value === null || value === void 0 ? void 0 : value.phone);
    const phoneAreaCode = phone.substring(0, 2);
    const phoneNumber = phone.substring(2);
    return {
      phoneNumber,
      phoneAreaCode,
      phoneCountryCode: '55'
    };
  }).test('is-phone', 'Phone is invalid', value => {
    const {
      phoneNumber,
      phoneAreaCode
    } = value;
    return (0, _isValidPhone.isValidPhone)(`${phoneAreaCode}${phoneNumber}`);
  });
});
const documentSchema = (0, _yup.string)().cpf().required();
exports.documentSchema = documentSchema;
const emailSchema = (0, _yup.string)().email().required();
exports.emailSchema = emailSchema;
const stringPhoneSchema = (0, _yup.object)().cellphone().required();
exports.stringPhoneSchema = stringPhoneSchema;
const phoneSchema = (0, _yup.object)({
  countryCode: (0, _yup.string)(),
  areaCode: (0, _yup.string)(),
  number: (0, _yup.string)()
}).phone().nullable();
exports.phoneSchema = phoneSchema;
const authenticateSchema = (0, _yup.object)().camelCase().shape({
  accessToken: (0, _yup.string)().required(),
  expiresIn: (0, _yup.number)().required(),
  legacyAccessToken: (0, _yup.string)().nullable()
});
exports.authenticateSchema = authenticateSchema;
const smartSigninSchema = (0, _yup.object)().camelCase().shape({
  hasPassword: (0, _yup.boolean)().required(),
  hasEmail: (0, _yup.boolean)().required(),
  hasCellphone: (0, _yup.boolean)().required()
});
exports.smartSigninSchema = smartSigninSchema;
const passwordResetSchema = (0, _yup.object)().camelCase().shape({
  email: (0, _yup.string)().nullable(),
  phone: phoneSchema
});
exports.passwordResetSchema = passwordResetSchema;
const passwordlessLoginSchema = (0, _yup.object)().camelCase().shape(verificationTicketSchema);
exports.passwordlessLoginSchema = passwordlessLoginSchema;
const accountInformationSchema = (0, _yup.object)({
  screenName: (0, _yup.string)().nullable(),
  authenticationClaims: (0, _yup.array)().of((0, _yup.object)({
    type: (0, _yup.string)().required(),
    status: (0, _yup.string)().required(),
    taken: (0, _yup.boolean)().required()
  })),
  customer: (0, _yup.object)({
    id: (0, _yup.string)()
  }).notRequired().default(undefined)
}).camelCase().required();
exports.accountInformationSchema = accountInformationSchema;
const emailOrDocumentSchema = (0, _yup.lazy)(value => {
  switch (value.type) {
    case 'EMAIL':
      return (0, _yup.object)({
        type: (0, _yup.string)().required(),
        verificationTicket: (0, _yup.string)().required()
      });

    case 'MAIN_DOCUMENT':
      return (0, _yup.object)({
        type: (0, _yup.string)().required(),
        documentCode: (0, _yup.string)().required()
      });

    default:
      return (0, _yup.mixed)();
  }
});
const createAccountSchema = (0, _yup.object)({
  screenName: (0, _yup.string)().nullable(),
  authenticationClaims: (0, _yup.array)().of(emailOrDocumentSchema).required()
}).camelCase().required();
exports.createAccountSchema = createAccountSchema;
const createCustomerSchema = (0, _yup.object)().camelCase().shape({
  customerId: (0, _yup.string)().required(),
  legacyAccessToken: (0, _yup.string)().required()
});
exports.createCustomerSchema = createCustomerSchema;
const requestClaimAdditionSchema = (0, _yup.object)().camelCase().shape({
  id: (0, _yup.string)().required(),
  type: (0, _yup.string)().required(),
  emailAddress: (0, _yup.string)().email().when('type', validateClaim(_enums.CLAIM_TYPES.email)),
  phoneNumber: (0, _yup.string)().when('type', validateClaim(_enums.CLAIM_TYPES.cellphone)),
  phoneAreaCode: (0, _yup.string)().when('type', validateClaim(_enums.CLAIM_TYPES.cellphone)),
  phoneCountryCode: (0, _yup.string)().when('type', validateClaim(_enums.CLAIM_TYPES.cellphone)),
  ...verificationTicketSchema
});
exports.requestClaimAdditionSchema = requestClaimAdditionSchema;
const verifyClaimSchema = (0, _yup.object)().camelCase().shape({
  id: (0, _yup.string)().required(),
  type: (0, _yup.string)().required(),
  status: (0, _yup.string)(),
  taken: (0, _yup.boolean)(),
  emailAddress: (0, _yup.string)().email().when('type', validateClaim(_enums.CLAIM_TYPES.email)),
  phoneNumber: (0, _yup.string)().when('type', validateClaim(_enums.CLAIM_TYPES.cellphone)),
  phoneAreaCode: (0, _yup.string)().when('type', validateClaim(_enums.CLAIM_TYPES.cellphone)),
  phoneCountryCode: (0, _yup.string)().when('type', validateClaim(_enums.CLAIM_TYPES.cellphone))
});
exports.verifyClaimSchema = verifyClaimSchema;
const resendVerificationCodeSchema = (0, _yup.object)().camelCase().shape(verificationTicketSchema);
exports.resendVerificationCodeSchema = resendVerificationCodeSchema;